import cn from 'classnames';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReportsApi from '../../../../API/shipment/reports-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../../components/Basic/Buttons';
import { LinkBlue } from '../../../../components/Basic/Elements';
import { Content, PageTitle } from '../../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../../components/Basic/Table';
import { H1, H3, Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { MARKET_IP, REPORT_STATUS_TEXT, STATUS_COLORS, TYPE_BUTTONS } from '../../../../constans';
import { MAP_SKLAD_RUS_ALL, SKLAD_LIST_ALL } from '../../../../constans/index';
import { getDate, getDateMonth, numberWithSpaces } from '../../../../utils';
import AddToRealizationPopUp from '../../../Shipments/Shipment/PopUps/AddToRealization';
import ReportLine from './ReportLine';
import styles from './styles.module.scss';

const MARKETS = {
  ozon: ['OZON-1', 'OZON-2', 'OZON-3', 'OZON-4', 'OZON-5', 'OZON-6', 'OZON-7'],
  yandex: ['B-WHITE FBS', 'U-RURU FBS'],
  wb: ['WB-1', 'WB-2', 'WB-3', 'WB-4', 'WB-5', 'WB-6', 'WB-7'],
  megamarket: ['SBER-1', 'SB ER-2'],
};

const SHOPS = {
  ozon: ['ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['megamarket1', 'megamarket2'],
  avito: ['avito1']
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];

const MODES = ['Режим реализации', 'Режим отчета'];
const MODES_OWNER = ['Режим реализации', 'Режим отчета'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];

const MAP_STATUS_REPORT_1C = {
  'Не выбран': undefined,
  Проведено: 'confirmed',
  'Не проведено': 'not_confirmed',
  'Дубль операции': 'double',
  Обработано: 'processed',
};

const STATUSES_SHIPMENT = ['Не выбран', 'Разложен (не упакован)', 'Упакован', 'Не отсортированы', 'Отсортированы'];

const FILTER_REPORT = {
  0: 'all',
  1: 'sold',
  2: 'returned',
};

const FILTER_REALIZATIONS = [
  'all',
  'fiz',
  'jur',
  'op3',
  'op2',
  'op1',
  'op_empty',
  'fbo',
  'old_realization',
  'not_in_realization',
];

let FILLTER_MAP = {
  [MODES[0]]: FILTER_REALIZATIONS,
  [MODES[1]]: FILTER_REPORT,
};

function MarketReportPage({ isExpress = false }) {
  const { id } = useParams();

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();
  const [shipment, setShipment] = useState({ market: '', shop: '', date_realization: '' });
  const [shipments, setShipments] = useState([]);

  const [calc, setCalc] = useState({ sold: 0, return: 0, diff: 0 });
  const [showRealization, setShowRealization] = useState(false);

  const [checkAll, setCheckAll] = useState(false);

  const [packagingMode, changePackagingMode] = useState(false);
  const [skladName, setSkladName] = useState('Не выбран');
  const [saleSchema, setSaleSchema] = useState('Не выбрана');

  const [shipmentMode, setShipmentMode] = useState('Режим реализации');

  const [postingsPrint, setPostingsPrint] = useState({});

  const [isMany, setIsMany] = useState(isExpress);

  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [shop, setShop] = useState('');

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [market, setMarket] = useState(Object.keys(MARKETS)[0]);
  const [dateFinance, setDateFinance] = useState(new Date());
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');
  const [sortFilter, setSortFilter] = useState({ name: 'Не выбрана', v: undefined });



  const [rates, setRates] = useState({});
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });

  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [chzn, setChzn] = useState('Не выбран');

  const [status, changeStatus] = useState(STATUSES[0]);
  const [statusShipment, changeStatusShipment] = useState(STATUSES_SHIPMENT[0]);

  const [orderStatus, changeOrderStatus] = useState('Не выбран');
  const [operationStatus, changeOperationStatus] = useState('Не выбран');

  const [confrimedByReportsMap, setConfrimedByReportsMap] = useState({});
  const [providerMap, setProviderMap] = useState({});
  const [reports, setReports] = useState({ ids: [], byIds: {}, map: {} });

  const loadData = () => {
    ReportsApi.getReportItems({ data: params })
      .then((res) => {
        const {
          data,
          reportItems,
          cardsMap = {},
          providersMap = {},
          count,
          all_count,
          finances,
          confrimedByReportsMap,
        } = res;
        const byIds = {};
        setCountStock(
          shipmentMode === MODES[0]
            ? [
              all_count.all,
              all_count.fiz,
              all_count.jur,
              all_count.op3,
              all_count.op2,
              all_count.op1,
              all_count.op_empty,
              all_count.fbo,
              all_count.old_realization,
              all_count.not_in_realization,
            ]
            : [all_count.all, all_count.sold, all_count.returned],
        );

        const ids = reportItems.map((item) => item._id);
        reportItems.forEach((item) => (byIds[item._id] = item));

        // dispatch(addShipmentPostings({ byIds, ids, map: cardsMap }));

        setReports({ byIds, ids, map: cardsMap });
        setProviderMap(providersMap);
        setConfrimedByReportsMap(confrimedByReportsMap);
        setPostingsPrint({});
        setCalc(finances);

        if (res.reports.length === 1 && !isExpress) {
          setShipment(res.reports[0]);
        } else {
          setShipments(res.reports);
        }

        setCount(count);
        //setLoad(true);
        setShop(res.reports[0].shop);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 140) {
          setError('Не удалось отгрузку');
        }
      });
  };

  const onChangeReport = (key, value) => {
    ReportsApi.changeReport({ data: { reportId: shipment.id, field: key, value } }).then((d) => loadData());
  };

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const clickConfirmReport = async () => {
    await ReportsApi.confirmReport({ data: { reportId: shipment.id } })
  };

  useEffect(() => {
    setMarket(Object.keys(MARKETS)[0]);
  }, []);

  const params = useMemo(() => {
    const shop_name = shopName === 'Все' ? '' : shopName;

    let realizations_ids = undefined;
    if (!isExpress) {
      // не экспрессы
      realizations_ids = id.split('&');
      realizations_ids = realizations_ids.map((item) => parseInt(item));
    }

    return {
      reportIds: realizations_ids,
      shipmentFilter: isExpress
        ? {
          isExpress,
          shipmentState: 'started',
        }
        : undefined,
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILLTER_MAP[shipmentMode]?.[tab],
      market: realizations_ids?.length === 1 || marketMany === 'Не выбрана' ? undefined : marketMany.toLowerCase(),
      shop: shop_name,
      filters: {
        status_1c: MAP_STATUS_REPORT_1C[operationStatus],
        saleSchema: saleSchema === 'Не выбрана' ? undefined : saleSchema,
        skladName: MAP_SKLAD_RUS_ALL[skladName],
      },
      sortType: sortFilter.v
    };
  }, [
    id,
    show,
    page,
    search,
    tab,
    provider.id,
    status,
    shopName,
    orderStatus,
    statusShipment,
    marketMany,
    chzn,
    operationStatus,
    saleSchema,
    skladName,
    shipmentMode,
    sortFilter
  ]);

  useEffect(() => {
    loadData();
    setIsMany(id.split('&').length > 1);
  }, [params]);

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_print = {};

      setPostingsPrint(map_print);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      setPostingsPrint({});
    }
  };
  const tab_name =
    isMany || isExpress
      ? isExpress
        ? 'Экспрессы'
        : 'Cовместный отчет'
      : `Отчёт: ${shipment.market || ''} ${shipment.date_realization ? getDate(shipment.date_realization) : ''}`;

  const modes = isOwner ? MODES_OWNER : MODES;

  useEffect(() => {
    setShopName('Все');
  }, [marketMany]);

  const shipments_text = shipments.map(
    (item) =>
      `${item.market || ''} ${item.is_express ? ' Express ' : ''} ${item.date_realization ? getDateMonth(item.date_realization) : ''
      }`,
  );

  //console.log(providerMap)
  return (
    <>
      <PageTitle title={tab_name} />
      <Content>
        <H1 style={{ marginBottom: '-3px' }}>
          {isMany || isExpress
            ? `Совместный отчёт: ${shipments.map(sh => sh.shop + ' (' + moment(new Date(sh.period?.end)).format('YY.MM.DD') + ')').join(' + ')}`
            : `Отчет: ${shipment.market || ''}/ ${shipment.shop} ${getDate(shipment.period?.start)}-${getDate(
              shipment.period?.end,
            )}  (${MARKET_IP[shipment.shop]})`}
        </H1>
        <LinkBlue to={'/report/reports/'} style={{ marginBottom: '10px' }}>
          Вернуться к отчетам
        </LinkBlue>

        {!isMany && (
          <Row style={{ alignItems: 'flex-start' }}>
            <>
              <WhiteBlock style={{ minWidth: '600px', alignSelf: 'normal' }} minimize={true}>
                <H3 style={{ marginBottom: '15px' }}>
                  Статус:{' '}
                  <span style={{ color: STATUS_COLORS[shipment.status] }} className={styles.status}>
                    {REPORT_STATUS_TEXT[shipment.status]}
                  </span>
                </H3>
                <Row>
                  <Column>
                    {isOwner && (
                      <Row style={{ alignItems: 'flex-end' }}>
                        <Row style={{ marginRight: '10px' }}>
                          <div>
                            <Select
                              list={SHOPS[shipment.market]}
                              select={shop}
                              label="Магазин"
                              onSelect={(v) => onChangeReport('shop', v)}
                              width={'200px'}
                              disabled={true}
                            />
                          </div>
                        </Row>
                        <DateInput
                          label="Дата начала периода"
                          classNameCalendar={styles.date_input}
                          className={styles.calendar}
                          value={shipment.period?.start}
                          //disabled={true}
                          onChange={(v) => onChangeReport('period_start', new Date(v))}
                        />
                        <DateInput
                          label="Дата конца периода"
                          classNameCalendar={styles.date_input}
                          className={styles.calendar}
                          value={shipment.period?.end}
                          //disabled={true}
                          onChange={(v) => onChangeReport('period_end', new Date(v))}
                        />
                        <Row>
                          <Select
                            label="Тип отчета"
                            select={shipment.type}
                            list={['Основной', 'Выкупной']}
                            onSelect={(v) => onChangeReport('type', v)}
                            width="150px"
                            style={{ marginRight: '15px' }}
                          />
                        </Row>
                        <Row>
                          <Input
                            label="Номер отчеты"
                            value={shipment.report_id_wb}
                            width={'200px'}
                            onBlur={(v) => onChangeReport('report_id_wb', v)}
                          />
                        </Row>
                      </Row>
                    )}
                    <Column style={{ marginTop: '15px' }}>
                      <Row>
                        <SendButton
                          sendApi={shipment.market === 'yandex' ? ReportsApi.saveReportYandex : ReportsApi.saveReport}
                          sendData={{ data: { reportId: parseInt(shipment.id), shop } }}
                          style={{ marginRight: '10px' }}
                        >
                          Подгрузить отчет
                        </SendButton>

                        <SendButton
                          multiple={true}
                          sendApi={ReportsApi.saveReportJur}
                          sendData={{ data: { reportId: parseInt(shipment.id), shop } }}
                          style={{ marginRight: '5px' }}
                        >
                          Подгрузить информацию о юр. лицах
                        </SendButton>
                        <SendButton
                          sendApi={shipment.market === 'wb' ? ReportsApi.saveReportPricesWbCommissar : ReportsApi.saveReportOzonCommissar}
                          sendData={{ data: { reportId: parseInt(shipment.id), shop } }}
                          style={{ marginRight: '5px' }}
                          disabled={shipment.market !== 'wb' && shipment.market !== 'ozon'}
                        >
                          Подгрузить выкупленые товары
                        </SendButton>
                        <Button
                          type={TYPE_BUTTONS.BLUE}
                          onClick={() => ReportsApi.createReportRealization({ data: { reportId: shipment.id } })}

                          style={{ marginLeft: '10px' }}
                        >
                          Перенести в подотчетные реализации
                        </Button>
                        <Button
                          type={TYPE_BUTTONS.BLUE}
                          onClick={() => ReportsApi.loadWbReport({ data: { reportId: shipment.id } })}
                          disabled={shipment.market != 'wb'}
                          style={{ marginLeft: '10px' }}
                        >
                          Выгрузить отчет
                        </Button>
                        <Button
                          type={TYPE_BUTTONS.GREEN}
                          onClick={() => clickConfirmReport()}
                          style={{ marginLeft: '15px' }}
                        >
                          Провести отчет
                        </Button>
                      </Row>

                      <Row style={{ marginTop: '15px' }}>
                        <Column style={{ marginRight: '15px' }}>
                          <Button
                            type={TYPE_BUTTONS.WHITE}
                            onClick={() =>
                              ReportsApi.excelReport({
                                data: {
                                  ...params,
                                  limit: undefined,
                                  page: undefined,
                                  sortType: undefined,
                                  customerType: 'fiz',
                                  type: 'xlsx',
                                  operation_1c: '03',
                                }
                              })
                            }
                            style={{ marginBottom: '5px', background: 'rgb(250 255 42 / 58%)' }}
                          >
                            Выгрузка для 1С xlsx ОП_03
                          </Button>
                          <Button
                            type={TYPE_BUTTONS.WHITE}
                            onClick={() =>
                              ReportsApi.excelReport({
                                data: {
                                  ...params,
                                  limit: undefined,
                                  page: undefined,
                                  sortType: undefined,
                                  customerType: 'fiz',
                                  type: 'xml',
                                  operation_1c: '03',
                                }
                              })
                            }
                            style={{ background: 'rgb(250 255 42 / 58%)' }}
                          >
                            Выгрузка для 1С xml ОП_03
                          </Button>
                        </Column>

                        <Column style={{ marginRight: '15px' }}>
                          <Button
                            type={TYPE_BUTTONS.WHITE}
                            onClick={() =>
                              ReportsApi.excelReport({
                                data: {
                                  ...params,
                                  limit: undefined,
                                  page: undefined,
                                  sortType: undefined,
                                  customerType: 'jur',
                                  type: 'xlsx',
                                  operation_1c: '03',

                                }
                              })
                            }
                            style={{ marginBottom: '5px', background: 'rgb(255 209 42 / 58%)' }}
                          >
                            Выгрузка для 1С xlsx ОП_03_юр
                          </Button>
                          <Button
                            type={TYPE_BUTTONS.WHITE}
                            onClick={() =>

                              ReportsApi.excelReport({
                                data: {
                                  ...params,
                                  limit: undefined,
                                  page: undefined,
                                  sortType: undefined,
                                  customerType: 'jur',
                                  type: 'xml',
                                  operation_1c: '03',
                                }
                              })
                            }
                            style={{ background: 'rgb(255 209 42 / 58%)' }}
                          >
                            Выгрузка для 1С xml ОП_03_юр
                          </Button>
                        </Column>

                        <Column style={{ marginRight: '15px' }}>
                          <Button
                            type={TYPE_BUTTONS.WHITE}
                            onClick={() =>
                              ReportsApi.excelReport({
                                data: {
                                  ...params,
                                  limit: undefined,
                                  page: undefined,
                                  sortType: undefined,
                                  customerType: 'com',
                                  type: 'xlsx',
                                  operation_1c: '03',
                                }
                              })
                            }
                            style={{ marginBottom: '5px', background: 'rgb(250 255 42 / 58%)' }}
                          >
                            Выгрузка для 1С xlsx ОП_03_выкуп
                          </Button>
                          <Button
                            type={TYPE_BUTTONS.WHITE}
                            onClick={() =>
                              ReportsApi.excelReport({
                                data: {
                                  ...params,
                                  limit: undefined,
                                  page: undefined,
                                  sortType: undefined,
                                  customerType: 'com',
                                  type: 'xml',
                                  operation_1c: '03',
                                }
                              })
                            }
                            style={{ background: 'rgb(250 255 42 / 58%)' }}
                          >
                            Выгрузка для 1С xml ОП_03_выкуп
                          </Button>
                        </Column>

                        <Column style={{ marginRight: '15px' }}>
                          <Button
                            type={TYPE_BUTTONS.WHITE}
                            onClick={() =>
                              ReportsApi.excelReport({
                                data: {
                                  ...params,
                                  limit: undefined,
                                  page: undefined,
                                  sortType: undefined,
                                  type: 'xlsx',
                                  operation_1c: '02в',
                                }
                              })
                            }
                            style={{ marginBottom: '5px', background: 'rgb(255 101 42 / 58%)' }}
                          >
                            Выгрузка для 1С xlsx ОП_02в
                          </Button>
                          <Button
                            type={TYPE_BUTTONS.WHITE}
                            onClick={() =>
                              ReportsApi.excelReport({
                                data: {
                                  ...params,
                                  limit: undefined,
                                  page: undefined,
                                  sortType: undefined,
                                  type: 'xml',
                                  operation_1c: '02в',
                                }
                              })

                            }
                            style={{ background: 'rgb(255 101 42 / 58%)' }}
                          >
                            Выгрузка для 1С xml ОП_02в
                          </Button>
                        </Column>
                      </Row>
                    </Column>
                  </Column>
                  <Column style={{ marginTop: '14px' }}></Column>
                </Row>
              </WhiteBlock>
              <WhiteBlock style={{ minWidth: '600px', alignSelf: 'normal', marginLeft: '15px' }} minimize={true}>
                <H3>Сводка</H3>
                <Row style={{ marginTop: '20px' }}>
                  <InputLabel styles={styles.label}>Продажи: </InputLabel>
                  <Text styles={styles.green_dark}>+ {numberWithSpaces(shipment?.total?.sale)}</Text>
                </Row>
                <Row>
                  <InputLabel styles={styles.label}>Возвраты: </InputLabel>
                  <Text styles={styles.red}>- {numberWithSpaces(shipment?.total?.returned)}</Text>
                </Row>
                <Row>
                  <InputLabel styles={styles.label}>Итого реализовано (за вычетом возвратов) (руб.): </InputLabel>
                  <Text styles={styles.green}>+ {numberWithSpaces(shipment?.total?.diff)}</Text>
                </Row>
              </WhiteBlock>
            </>
          </Row >
        )
        }

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={
                shipmentMode === MODES[0]
                  ? [
                    'Все операции',
                    'Продажи физ. лицам',
                    'Продажи юр. лицам',
                    'ОП_3',
                    'ОП_2',
                    'ОП_1',
                    'Ожидает обработки',
                    'Заказы FBO',
                    'Заказы с 2024 года',
                    'Нет в реализации',
                  ]
                  : ['Все операции', 'Продажи', 'Возвраты']
              }
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
            <Row>
              <div>
                <Select
                  select={shipmentMode}
                  list={modes}
                  onSelect={(v) => setShipmentMode(v)}
                  width="200px"
                />
              </div>
            </Row>
          </Row>

          <Row className={styles.row_input}>
            {Object.keys(postingsPrint).length > 0 ? (
              <Row className={styles.row_select}>
                <Row>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    style={{ marginRight: '15px' }}
                    onClick={() => {
                      setCheckAll(false);
                      setPostingsPrint({});
                      setTimeout(setInputFocus, 1000);
                    }}
                  >
                    Очистить выбор
                  </Button>
                </Row>
              </Row>
            ) : (
              <Input
                value={search}
                ref={inputRef}
                onBlur={(v) => setSearch(v)}
                onClickEnter={(v) => setSearch(v)}
                label="Поиск"
              />
            )}
          </Row>

          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

          <Row spaceBetween={true}>
            <Row style={{ height: '40px' }}>
              <div>
                <Select
                  label="Показать на странице"
                  select={show}
                  list={['20', '50', '100', '150', '200', '500', '1000']}
                  onSelect={(v) => setShow(v)}
                  width="150px"
                  style={{ marginRight: '15px' }}
                />
              </div>

              {isMany && (
                <>
                  <Select
                    list={MARKETS_LIST}
                    select={marketMany}
                    label="Площадка"
                    onSelect={(v) => setMarketMany(v)}
                    width={'150px'}
                    style={{ marginRight: '15px' }}
                  />
                  <Select
                    list={SHOPS[marketMany.toLowerCase()] || []}
                    select={shopName}
                    disabled={marketMany === MARKETS_LIST[0]}
                    label="Магазин"
                    onSelect={(v) => setShopName(v)}
                    width={'150px'}
                    style={{ marginRight: '15px' }}
                  />
                </>
              )}

              <Select
                label="Поставщик"
                select={provider}
                valueFn={(p) => p.name}
                list={providers}
                width="200px"
                onSelect={(v) => changeProvider(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Статус операции"
                select={operationStatus}
                list={['Не выбран', 'Проведено', 'Не проведено', 'Обработано', 'Дубль операции']}
                width="200px"
                onSelect={(v) => changeOperationStatus(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Склад отгрузки"
                select={skladName}
                list={SKLAD_LIST_ALL}
                width="200px"
                onSelect={(v) => setSkladName(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Схема отгрузки"
                select={saleSchema}
                list={['Не выбрана', 'fbs', 'fbo', 'express']}
                width="200px"
                onSelect={(v) => setSaleSchema(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                valueFn={(p) => p.name}
                label="Сортировка по"
                select={sortFilter}
                list={[{ name: 'Не выбрана', v: undefined }, { name: 'Дате продажи', v: 'sale_date' }, { name: 'Дате продажи возвратов', v: 'sale_pair_date' }]}
                width="215px"
                onSelect={(v) => setSortFilter(v)}
                style={{ marginRight: '15px' }}
              />

              {(tab === 5 || tab === 6 || saleSchema === 'fbo') && (
                <Button
                  type={TYPE_BUTTONS.GREEN}
                  style={{ marginRight: '15px' }}
                  onClick={() => setShowRealization(true)}
                >
                  Перенести в реализацию
                </Button>
              )}

              {/*            
              <Select
                label="Статус заказа"
                select={orderStatus}
                list={isMany ? STATUSES_ALL : STATUSES_ORDERS[shipment.market]}
                width="200px"
                style={{ marginRight: '15px' }}
                onSelect={(v) => changeOrderStatus(v)}
              />*/}
            </Row>
            {/*  <Column className={styles.column_button}></Column>*/}
          </Row>
        </WhiteBlock>

        <Table styles={styles.table}>
          {(user.role === 'owner' || user.role === 'admin') && (
            <TableHeader whiteHeader>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Итого реализовано (за вычетом возвратов): </TextGrey>
                <Text className={cn(styles.profit, calc.diff > 0 ? styles.green : styles.red)}>
                  {calc.diff > 0 && '+ '}
                  {numberWithSpaces(Math.ceil(calc.diff))}
                </Text>
              </Row>
              <Row className={styles.block_calc} style={{ marginLeft: '40px' }}>
                <TextGrey className={styles.text_grey}>Реализовано на сумму, руб.: </TextGrey>
                <Text className={cn(styles.profit, calc.sale >= 0 ? styles.green_dark : styles.red)}>
                  {calc.sale >= 0 ? '+ ' : '- '}
                  {numberWithSpaces(Math.ceil(calc.sale))}
                </Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Итого возвращено, руб.: </TextGrey>
                <Text className={cn(styles.profit)}>
                  {'- '}
                  {numberWithSpaces(Math.ceil(calc.returned))}
                </Text>
              </Row>
            </TableHeader>
          )}
          <TableHeader whiteHeader>
            {shipmentMode === modes[0] && (
              <>
                <HeaderTitle width={WIDTH_POSTING[9]}>
                  {/*                   <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
                   */}{' '}
                </HeaderTitle>
              </>
            )}
            <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[1]} centerText={true}>
              Позиции в заказе
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[1]} centerText={true}>
              Наименование товара
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Артикул 1c
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
              Количество
            </HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Сумма реализации
            </HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Статус заказа
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Статус операции
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>
              Поставщик
            </HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Отчет о продаже
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>
              Дата продажи
            </HeaderTitle>
            {tab === 2 && (
              <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                Информация о юр. лице
              </HeaderTitle>
            )}
          </TableHeader>
          {reports.ids.map((report) => {
            let item = reports.byIds[report];

            const confrimedByReportsItem = confrimedByReportsMap[item.info_1c?.id_confirmed_by_report];
            return (
              <ReportLine
                shipmentMode={shipmentMode}
                packagingMode={packagingMode}
                MODES={modes}
                FILTER={FILLTER_MAP[shipmentMode]}
                tab={tab}
                report={reports.byIds[report]}
                shipment={shipment}
                map={reports.map}
                key={reports.byIds[report]._id}
                setInputFocus={setInputFocus}
                postingsPrint={postingsPrint}
                isMany={isMany}
                providerMap={providerMap}
                confrimedByReportsItem={confrimedByReportsItem}
              />
            );
          })}
        </Table>

        {
          showRealization && (
            <AddToRealizationPopUp
              postings={
                shipment.market === 'wb'
                  ? reports.ids.map((id) => reports.byIds[id].wb_posting_number)
                  : reports.ids.map((id) => reports.byIds[id].posting_number)
              }
              market={shipment.market}
              num={reports.ids.map((id) => reports.byIds[id].posting_number).length}
              shop={shop}
              date={new Date('01.01.2025')}
              close={() => {
                setShowRealization(false);
                loadData();
              }}
            />
          )
        }
        <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
      </Content >
    </>
  );
}

export default MarketReportPage;
